import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import RadioInput from '../inputs/radio.input'
import { RadioList } from '@utils/request'
import * as utilsList from './__index.utils'
import BlobUploader from '../inputs/azureBlobUploader.input'


const Step3_4TypeUtilisation = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	isSummaryStep = false,
	// *******
	toPrint = false
}) => {
	const {
		whatToDo,

		// **********************
		mainUseOfExistingBuilding,


		existingMainBuildingIsShared,
	} = formInputs



	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)

	const radioListMainUseOfExistingBuilding: RadioList[] =
		utilsList.radioListMainUseOfExistingBuildingCommercialPermit3(pageAssets)




	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_type_of_use}
				</h4>
			)}

			<RadioInput
				name={mainUseOfExistingBuilding.name}
				label={mainUseOfExistingBuilding.label}
				value={mainUseOfExistingBuilding.value}
				list={radioListMainUseOfExistingBuilding}
				direction={Direction.vertical}
				hasError={errors!.includes(mainUseOfExistingBuilding.name)}
				onChange={(value) => updateInput(mainUseOfExistingBuilding.name, value)}
				ref={mainUseOfExistingBuilding.ref as RefObject<HTMLInputElement>}
				required={mainUseOfExistingBuilding.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>

			<RadioInput
				name={existingMainBuildingIsShared.name}
				label={existingMainBuildingIsShared.label}
				value={existingMainBuildingIsShared.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors!.includes(existingMainBuildingIsShared.name)}
				onChange={(value) =>
					updateInput(existingMainBuildingIsShared.name, value)
				}
				ref={existingMainBuildingIsShared.ref as RefObject<HTMLInputElement>}
				required={existingMainBuildingIsShared.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>			
		</>
	)
}

export default Step3_4TypeUtilisation
